import React from "react";
import "./aboutSec.css";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const AboutSec = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="aboutSec">
      {isMobile ? (
        <div className="mobile-version">
          <div className="aboutSec-container">
            <div className="aboutSec-left">
              <h1>
                Creative <span className="title-word">Digital Marketing</span>
                to Amplify Your Brand and Drive Growth
              </h1>
              <div className="image-box">
                <LazyLoadImage
                  src={require("../../assets/About-section-image.jpg")}
                  alt="About Us Picture"
                  effect="blur"
                />
              </div>
            </div>
            <div className="aboutSec-right">
              <div className="text-wrapper">
                <p>
                  At <span className="desc-word">CS Lab</span>, we help startups
                  and small businesses amplify their voice and connect with
                  their audience. Through creative and strategic marketing, we
                  turn challenges into opportunities, driving growth and making
                  your brand stand out in the competitive USA market.
                </p>
                <Link to="/about" onClick={handleClick}>
                  <button className="btn">Learn More About Us</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="aboutSec-container">
            <div className="aboutSec-left">
              <div className="text-wrapper">
                <h1>
                  Creative <span className="title-word">Digital Marketing</span>
                  to Amplify Your Brand and Drive Growth
                </h1>
                <p>
                  At <span className="desc-word">CS Lab</span>, we help startups
                  and small businesses amplify their voice and connect with
                  their audience. Through creative and strategic marketing, we
                  turn challenges into opportunities, driving growth and making
                  your brand stand out in the competitive USA market.
                </p>
                <Link to="/about" onClick={handleClick}>
                  <button className="btn">Learn More About Us</button>
                </Link>
              </div>
            </div>
            <div className="aboutSec-right">
              <div className="image-box">
                <LazyLoadImage
                  src={require("../../assets/About-section-image.jpg")}
                  alt="About Us Picture"
                  effect="blur"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default AboutSec;
